// src/app/models/user.model.ts

import {Deserializable} from './deserializable.model';
// import {Car} from './car.model';
import {Address} from './address.model';

export class MyobContact implements Deserializable {
 /* public id: number;
  public firstName: string;
  public lastName: string;
  public position: string;
  public cars: Car[];
  */

// the MyobContacts Object
public UID?: string;
public LastName?: string;
public FirstName?: string;
  public IsIndividual?: boolean;
  public DisplayID?: string;
  public IsActive?: boolean;
  public Addresses?: Address[];
  public Notes?: string;
  public Identifiers?: any;
  public CustomList1?: any;
  public CustomList2?: any;
  public CustomList3?: any;
  public CustomField1?: CustomField1;
  public CustomField2?: CustomField2;
  public CustomField3?: CustomField3;
  public CurrentBalance?: number;
  public SellingDetails?: SellingDetails;
  public PaymentDetails?: PaymentDetails;
  public LastModified?: Date;
  public PhotoURI?: any;
  public URI?: string;
  public RowVersion?: string;
  public CompanyName?: string;

 
  deserialize(input: any): this {
    // Assign input to our object BEFORE deserialize our cars to prevent already deserialized cars from being overwritten.
    Object.assign(this, input);

    // Iterate over all cars for our user and map them to a proper `Car` model
    //  this.cars = input.cars.map(car => new Car().deserialize(car));

       // Iterate over all addresses for our myob_conntact and map them to a proper `Address` model
    this.Addresses = input.Addresses.map(address => new Address().deserialize(address));

    return this;
  }
  
  getFullName() {
    return this.FirstName + ' ' + this.LastName;
  }



}




export class Address2 {
    Location?: number;
    Street?: string;
    City?: string;
    State?: string;
    PostCode?: string;
    Country?: string;
    Phone1?: string;
    Phone2?: string;
    Phone3?: string;
    Fax?: string;
    Email?: string;
    Website?: string;
    ContactName?: string;
    Salutation?: string;
}

export interface CustomField1 {
    Label: string;
    Value: string;
}

export interface CustomField2 {
    Label: string;
    Value: string;
}

export interface CustomField3 {
    Label: string;
    Value: string;
}

export interface TaxCode {
    UID: string;
    Code: string;
    URI: string;
}

export interface FreightTaxCode {
    UID: string;
    Code: string;
    URI: string;
}

export interface Terms {
    PaymentIsDue: string;
    DiscountDate: number;
    BalanceDueDate: number;
    DiscountForEarlyPayment: number;
    MonthlyChargeForLatePayment: number;
    VolumeDiscount: number;
}

export interface Credit {
    Limit: number;
    Available: number;
    PastDue: number;
    OnHold: boolean;
}

export interface SellingDetails {
    SaleLayout: string;
    PrintedForm: string;
    InvoiceDelivery: string;
    ItemPriceLevel?: any;
    IncomeAccount?: any;
    ReceiptMemo: string;
    SalesPerson?: any;
    SaleComment: string;
    ShippingMethod?: any;
    HourlyBillingRate: number;
    ABN: string;
    ABNBranch: string;
    TaxCode: TaxCode;
    FreightTaxCode: FreightTaxCode;
    UseCustomerTaxCode: boolean;
    Terms: Terms;
    Credit: Credit;
    TaxIdNumber: string;
    Memo: string;
}

export interface PaymentDetails {
    Method: string;
    CardNumber?: any;
    NameOnCard: string;
    BSBNumber: string;
    BankAccountNumber: string;
    BankAccountName: string;
    Notes?: any;
}

 export interface CustomField1 {
        Label: string;
        Value: string;
    }

    export interface CustomField2 {
        Label: string;
        Value: string;
    }

    export interface CustomField3 {
        Label: string;
        Value: string;
    }

    export interface TaxCode {
        UID: string;
        Code: string;
        URI: string;
    }

    export interface FreightTaxCode {
        UID: string;
        Code: string;
        URI: string;
    }

    export interface Terms {
        PaymentIsDue: string;
        DiscountDate: number;
        BalanceDueDate: number;
        DiscountForEarlyPayment: number;
        MonthlyChargeForLatePayment: number;
        VolumeDiscount: number;
    }

    export interface Credit {
        Limit: number;
        Available: number;
        PastDue: number;
        OnHold: boolean;
    }

    export interface SellingDetails {
        SaleLayout: string;
        PrintedForm: string;
        InvoiceDelivery: string;
        ItemPriceLevel?: any;
        IncomeAccount?: any;
        ReceiptMemo: string;
        SalesPerson?: any;
        SaleComment: string;
        ShippingMethod?: any;
        HourlyBillingRate: number;
        ABN: string;
        ABNBranch: string;
        TaxCode: TaxCode;
        FreightTaxCode: FreightTaxCode;
        UseCustomerTaxCode: boolean;
        Terms: Terms;
        Credit: Credit;
        TaxIdNumber: string;
        Memo: string;
    }

    export interface PaymentDetails {
        Method: string;
        CardNumber?: any;
        NameOnCard: string;
        BSBNumber: string;
        BankAccountNumber: string;
        BankAccountName: string;
        Notes?: any;
    }

    



    export interface Refund {
        PaymentMethod: string;
        CardNumber: string;
        NameOnCard: string;
        Notes: string;
    }


  /*
  * convert the JOSIN results of an API to any Model/Class/Interface Struction
  * @source: http://json2ts.com/
  */  